import type { IEditorRecipientInput } from '@lib-shared/types/editor-recipient-input';
import type { ActionTree } from 'vuex';
import { translate } from '@lib-shared/helpers/translation.helper';
import { EditorViewService } from '../api/services/editor-view.service';
import type { UpdateInputFieldRequest } from '../api/services/types/requests';
import { EditorViewInputAction, EditorViewInputMutation } from './editor-view-input.constants';
import type { IEditorViewInputState } from './editor-view-input.types';
import type { EditorViewState } from './editor-view.types';

export const actions: ActionTree<IEditorViewInputState, EditorViewState> = {
  async [EditorViewInputAction.UpdateInputValue](
    { commit, dispatch },
    payload: UpdateInputFieldRequest
  ) {
    commit(EditorViewInputMutation.AddUpdatingInput, {
      fieldId: payload.fieldId,
      value: payload.value,
    });
    try {
      await EditorViewService.updateEditorInputField(payload);
      dispatch(EditorViewInputAction.UpdateInputValueSuccess, payload.fieldId);
    } catch (error) {
      dispatch(EditorViewInputAction.UpdateInputValueFailed, {
        fieldId: payload.fieldId,
        value: payload.value,
      });
    }
  },

  [EditorViewInputAction.UpdateInputValueSuccess]({ commit }, id: string) {
    commit(EditorViewInputMutation.ClearFailedInputUpdates, id);
    commit(EditorViewInputMutation.RemoveUpdatingInput, id);
  },

  [EditorViewInputAction.UpdateInputValueFailed](
    { commit, state, dispatch },
    input: IEditorRecipientInput
  ) {
    commit(EditorViewInputMutation.RemoveUpdatingInput, input.fieldId);
    if (state.updatingInputs.find(updatingInput => updatingInput.fieldId === input.fieldId)) {
      return;
    }
    commit(EditorViewInputMutation.AddToFailedInputUpdates, input);
    dispatch(
      EditorViewInputAction.SetAlert,
      translate('could-not-save-please-try-again-or-contact-support')
    );
  },

  [EditorViewInputAction.SetAlert]({ commit }, alert: string) {
    commit(EditorViewInputMutation.SetAlert, alert);
  },
};
